const env = (
  import.meta as ImportMeta & { env: Record<string, string | undefined> }
).env;
export const appName = env.VITE_APP_NAME ?? env.APP_NAME ?? "AIMAX";
